import React, { FC } from 'react';
import { Tag as BaseTag, TagProps, useTheme } from '@chakra-ui/react';
import styled from '@emotion/styled/macro';
import { rgba } from 'polished';
import { rem } from 'utils/fonts';

const StyledTag = styled(BaseTag)`
  border-radius: 48px;
  padding: 10px 19px;
  font-size: ${rem(12)};
  font-weight: bold;
`;

const Tag: FC<TagProps> = ({ children }) => {
  const { colors } = useTheme();
  return (
    <StyledTag color="pink.500" bg={rgba(colors.pink[200], 0.4)}>
      {children}
    </StyledTag>
  );
};

export default Tag;
